import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=d206108a&scoped=true&"
import script from "./FileSystem.vue?vue&type=script&lang=ts&"
export * from "./FileSystem.vue?vue&type=script&lang=ts&"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=d206108a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d206108a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
